module.exports = __webpack_public_path__ + "static/media/modo-impressao.ad97b01b.svg";